// extracted by mini-css-extract-plugin
export default {"signincontent":"SignIn_signincontent__2mMCj","signinp":"SignIn_signinp__pPNLc"};